// src/App.js
import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import {AppProvider} from "./context/AppContext";
import Header from "./components/Header";
import MachineList from "./components/MachineList";
import MachineDetail from "./components/MachineDetailView/MachineDetail";
import "./App.css";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <MachineList />
              </>
            }
          />
          <Route path="/:machineSerialNumber" element={<MachineDetail />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
